export enum ParentEntityType {
  FAMILY = 1,
  SITE = 2,
}
